import React from 'react'
import styles from './FullWidthImage.module.css'

const FullWidthImage = (props) => {
  return (
    <div className={`${props.small ? styles.smallContainer : styles.container}`} style={{ backgroundImage: `url(${props.image})` }}></div>
  )
}

export default FullWidthImage